import type { FC } from "react";
import { useMemo, useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { CircleSwitcherItem } from "@similarweb/ui-components";

import { isPaidSearchPagesAvailable } from "app/pages/keyword-research/utils/permissions";
import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";
import { SourceType } from "app/UtilitiesAndConstants/Constants/SourceTypes";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { SourceTypes, sourceTypeSwitcherItems } from "./const";
import { InlineWebsiteQueryBar } from "./inline-website-query-bar/InlineWebsiteQueryBar";
import { StyledSwitcher, KeywordsGapFiltersWrapper } from "./StyledComponents";

export const KeywordsGapFilters: FC = () => {
    const { vennDiagramSourceType } = useCurrentStateAndParams().params as { vennDiagramSourceType: string };
    const [selectedSourceTypeIndex, setSelectedSourceTypeIndex] = useState<SourceTypes>(
        SourceTypes[vennDiagramSourceType.toUpperCase()] as SourceTypes,
    );
    const sourceTypeSwitcherItemsFiltered = useMemo(
        () =>
            sourceTypeSwitcherItems.filter((item) =>
                !isPaidSearchPagesAvailable() ? item.id !== SourceType.PAID : true,
            ),
        [],
    );
    const onSwitcherItemClick = (index: SourceTypes) => {
        allTrackers.dispatchTrackEvent(
            "Button",
            "switch",
            `Traffic Type/${translate(sourceTypeSwitcherItems[index].id)}`,
        );
        void proNavigator.updateParams(
            { vennDiagramSourceType: SourceType[SourceTypes[index]] as string },
            { reload: false },
        );
        setSelectedSourceTypeIndex(index);
    };

    return (
        <KeywordsGapFiltersWrapper>
            <InlineWebsiteQueryBar />
            <StyledSwitcher
                selectedIndex={selectedSourceTypeIndex}
                onItemClick={onSwitcherItemClick as (index: number) => void}
                customClass="CircleSwitcher"
            >
                {sourceTypeSwitcherItemsFiltered.map((item) => {
                    return <CircleSwitcherItem key={item.id}>{translate(item.textKey)}</CircleSwitcherItem>;
                })}
            </StyledSwitcher>
        </KeywordsGapFiltersWrapper>
    );
};
